import { BreaksService, GetBreaksResponse } from "@/client";
import { HttpError } from "@/types/error";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

const breaksQueryKey = (
  congressId: string,
  pageSize = 10,
  pageIndex = 0,
  search?: string,
) => {
  return ["breaks", congressId, pageSize, pageIndex, search] as const;
};

function useGetBreaks(
  {
    congressId,
    pageSize = 10,
    pageIndex = 0,
    search,
  }: {
    congressId: string;
    pageSize?: number;
    pageIndex?: number;
    search?: string;
  },
  queryOptions?: Partial<UseQueryOptions<GetBreaksResponse, HttpError>>,
) {
  const offset = pageIndex * pageSize;

  return useQuery({
    queryKey: breaksQueryKey(congressId, pageSize, pageIndex, search),
    queryFn: () =>
      BreaksService.getBreaks({
        congressId,
        limit: pageSize,
        offset,
        search,
      }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}

export { breaksQueryKey, useGetBreaks };
